import SectionCategoryCarousel from './SectionCategoryCarousel';
export default SectionCategoryCarousel;
